import React from 'react';
import {Alert, AlertProps} from "antd";

export interface IAlertProps extends AlertProps {
    message: string; // 消息内容
    description?: string; // 描述内容（可选）
    type?: 'success' | 'info' | 'warning' | 'error';
    showIcon?: boolean; // 是否显示图标（可选）
    banner?: boolean;// 是否显示顶部公告（可选）
}

export const IAlert: React.FC<IAlertProps> = ({
    message,
    description,
    showIcon = true,
    banner= false,
    type = 'info', // 默认类型为 info
    ...restProps
}) => {
    return (
        <Alert
            message={message}
            description={description}
            type={type}
            banner={banner}
            showIcon={showIcon}
            {...restProps}
        />
    );
};
